/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exam_New_TitleInputs */

const da_exam_new_title = /** @type {(inputs: Exam_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny prøve`)
};

/** @type {(inputs: Exam_New_TitleInputs) => LocalizedString} */
const en_exam_new_title = da_exam_new_title;

/**

* @param {Exam_New_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const exam_new_title = /** @type {((inputs?: Exam_New_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exam_New_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exam_new_title(inputs)
	return /** @type {LocalizedString} */ ("Ny prøve")
});